
import "./Footer.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

import { getNevnap } from "../Nevnap/Nevnap";

function Footer() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  function getDateStringWithDay(dateObj) {
    const date = dateObj.toLocaleDateString('hu-HU').replace(/\./g, '.').replace(/\s/g, '');
    const days = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];
    const dayName = days[dateObj.getDay()];
    return `${date} ${dayName}`;
  }

  function getTimeString(dateObj) {
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const seconds = dateObj.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  return (
    <footer className="footer-telex">
      <div className="footer-main footer-main-row">
        <div className="footer-col footer-logo-col">
          <img src="/images/logo.webp" alt="Kútonline logó" className="footer-logo" />
        </div>
        <div className="footer-col footer-social-col">
          <h4 className="footer-keep-with-us">Maradj velünk!</h4>
          <div className="footer-social">
            <span className="footer-social-group">
              <a href="https://www.facebook.com/profile.php?id=61567973570958" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/kut_online/?fbclid=IwY2xjawLiO51leHRuA2FlbQIxMABicmlkETFFU29jRWFSU0dFUWx2QkszAR7WenFeG2vo8KNZCJmCzD0HEemaXu5NI-Ow-A6yojc1IDn57y7Jgi0jytdxPg_aem_HkGvZBQ1RHyn7Mz0I5ozYA#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.tiktok.com/@kutonlineujsag?fbclid=IwY2xjawLiO7VleHRuA2FlbQIxMABicmlkETFFU29jRWFSU0dFUWx2QkszAR7ql4Ld5fiwYM-qJnzAMHmFzoZ41FTEebXoaMZbl-w659DR4vFz0Oigkg565Q_aem_dxTQan4yEmyslJ-MfGUqrQ" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                <i className="fab fa-tiktok"></i>
              </a>
            </span>
            <span className="footer-social-group">
              <a href="https://discord.gg/Df3AQFePbg" target="_blank" rel="noopener noreferrer" aria-label="Discord">
                <i className="fab fa-discord"></i>
              </a>
              <a href="https://open.spotify.com/show/39b9U2AAiWPUFqcNIDj8cU?fbclid=IwY2xjawLiPE1leHRuA2FlbQIxMABicmlkETFFU29jRWFSU0dFUWx2QkszAR6C5yuX4Ca0PYmRgsRdPjw30PMBt2jh7EKHTrmvHhwG__gK2qnUPXBLMEJRkg_aem_lFTPsRkEKDMxaB18DOzOAw" target="_blank" rel="noopener noreferrer" aria-label="Spotify">
                <i className="fab fa-spotify"></i>
              </a>
              <a href="https://www.youtube.com/@kutonlineujsag?si=ZvbCbsJo2x5rXJeg&fbclid=IwY2xjawLiPBNleHRuA2FlbQIxMABicmlkETFFU29jRWFSU0dFUWx2QkszAR4_iH6BsSMtRIiCZbsTj5LJ4K6xDWC6L5-3ttJvTvo2OUWWSGq-SiKaKOe-AA_aem_d0awsq4OczJTf6VMK4t7Yg" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </span>
          </div>
        </div>
        <div className="footer-col footermenu">
          <h4>Főmenü</h4>
          <ul>
            <li><Link className="footer-link" to="/">Kezdőlap</Link></li>
            <li><Link className="footer-link" to="/columns">Rovatok</Link></li>
            <li><Link className="footer-link" to="/about">Rólunk</Link></li>
            <li><Link className="footer-link" to="/support">Támogatás</Link></li>
          </ul>
        </div>
        <div className="footer-col footercontact">
          <h4>Elérhetőség</h4>
          <ul>
            <li>Email: <a href="mailto:info@kutonline.hu">info@kutonline.hu</a></li>
            <li>Telefon: <a href="tel:+36702078479">+36 70 207 8479</a></li>
            <li><a href="/contact">Kapcsolat</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Adatvédelem</h4>
          <ul>
            <li><Link className="footer-link" to="/privacypolicy">Jogi nyilatkozat - Impresszum és Adatvédelem</Link></li>
            <li><Link className="footer-link" to="/copyright">Szerzői jogi és felhasználási feltételek</Link></li>
            <li><Link className="footer-link" to="/unsubscribe">Hírlevél leiratkozás</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-links">
          <a href="https://www.facebook.com/people/Vasi-Kutat%C3%B3csoport/61550089783319/">Vasi Kutatócsoport</a>
          <span>|</span>
          <span>{getDateStringWithDay(now)}</span>
          <span>|</span>
          <span className="footer-clock">{getTimeString(now)}</span>
          <span>|</span>
          <span>{getNevnap(now) || '—'}</span>
          
        </div>
        <div className="footer-copyright">
          &copy; {now.getFullYear()} Dunántúli Népművészeti Egyesület
        </div>
      </div>
    </footer>
  );
}

export default Footer;